import React from 'react';
import { Typography } from '@mui/material';
import { useDojezdOdpocet } from '../hooks/useDojezdOdpocet';
import { useDojezdNastaveni } from '../hooks/useDojezdNastaveni';

interface DojezdOdpocetProps {
    /** ISO cas, kdy ma hasic dorazit. Undefined = dojezd neuvedl. */
    dojezdCas?: string;
    /** ISO cas vyhlaseni poplachu — kotva pro skryti po vyprseni casu vyjezdu. */
    casVyhlaseni: string;
    /** Velikost pisma; karty se lisi mezi presety. */
    fontSize: string;
}

/**
 * Odpocet do prijezdu hasice do zbrojnice.
 *
 * Zamerne bez blikani: hlavni casovac poplachu (CasOdVyhlaseni) po limitu blika a druhy
 * blikajici prvek na tez obrazovce by ubral na srozumitelnosti, ne pridal.
 *
 * Limit `casVyjezdMinuty` si komponenta tahá sama z jednotky, aby se nemusel protahovat
 * pres tri ruzne renderovaci cesty odpovedi.
 */
const DojezdOdpocet: React.FC<DojezdOdpocetProps> = ({ dojezdCas, casVyhlaseni, fontSize }) => {
    const { casVyjezdMinuty, odpocetZapnut } = useDojezdNastaveni();
    // Prepinac je na jednotce, ne v konfiguraci displeje — ta je per device token,
    // takze nastaveni odtud by se na Raspberry Pi neprojevilo. Hradlo je zamerne
    // tady, v jedine komponente odpoctu: pokryje vsechny tri renderovaci cesty
    // (OdpovedKarta, TechnikaUcastWrapper, Vyjezd2026OdpovediSection) najednou.
    const { zobrazit, formatted, poCase } = useDojezdOdpocet(dojezdCas, casVyhlaseni, casVyjezdMinuty);

    if (!odpocetZapnut || !zobrazit) return null;

    return (
        <Typography
            component="span"
            data-testid="dojezd-odpocet"
            data-po-case={poCase ? 'true' : 'false'}
            sx={{
                fontSize,
                fontWeight: 800,
                lineHeight: 1,
                fontVariantNumeric: 'tabular-nums',
                whiteSpace: 'nowrap',
                // Pevna sirka: tabular-nums drzi stejnou sirku CISLIC, ne delku retezce,
                // takze prechod 10:00 -> 9:59 by jinak jednou za minutu presolvoval flex
                // radek a cukl jmenem hasice.
                minWidth: '3.5ch',
                textAlign: 'right',
                color: poCase ? 'error.main' : 'text.secondary',
            }}
        >
            {formatted}
        </Typography>
    );
};

export default DojezdOdpocet;
